class VehicleType {
  constructor(title, autoDisable) {
    this.title = title;
    this.autoDisable = autoDisable;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      vehicleTypeId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      vehicleTypeManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        {
          text: 'غیرفعال کردن اتوماتیک',
          value: 'autoDisable',
          align: 'center',
        },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن نوع وسیله نقلیه';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش نوع وسیله نقلیه';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getVehicleTypeFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.vehicleType = new VehicleType('', false);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addVehicleTypeFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش نوع وسیله نقلیه';
        this.$refs.confirm.text = 'از ویرایش نوع وسیله نقلیه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف نوع وسیله نقلیه';
        this.$refs.confirm.text = 'از حذف نوع وسیله نقلیه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addVehicleTypeFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editVehicleTypeFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteVehicleTypeFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.vehicleTypeId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
